module.exports = __webpack_public_path__ + "media/images/pic/materials/100-lecie-przyjazni-9659ff1696783fbb85aafac2a72fe79e.png";